import { get } from 'lodash'
import merge from 'lodash/merge'

import {
  FETCH_EVENTS_BEGIN,
  FETCH_EVENTS_ERROR,
  FETCH_EVENTS_SUCCESS,
} from '../actions/fetchEvents'
import { SET_FILTER_CONTENT } from '../actions/fetchFilterContent'

const initialState = {
  loading: false,
  error: null,
  data: null,
}

export default function eventsData(state = initialState, action) {
  switch (action.type) {
    case FETCH_EVENTS_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case FETCH_EVENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: merge({}, state.data, action.payload),
      }
    case FETCH_EVENTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case SET_FILTER_CONTENT:
      return {
        ...state,
        loading: false,
        data: merge({}, state.data, action.payload),
      }
    default:
      return state
  }
}

export const getAvailableLocations = (state) => {
  return get(state, 'eventsData.data.locations')
}
